import getDomain from './domain';

const getIsB2C = (rootState) => window.location.hostname === getDomain(rootState);

export default getIsB2C;
